/**
 * A ticket count with − and + either side (styles: stepper.css). The input
 * can be typed in too, and keeps its `name` so the form posts without
 * JavaScript; `noun` words the buttons ("Fleire ordinærbillettar").
 */
export function QuantityStepper({
	id,
	name,
	value,
	onChange,
	noun,
	max,
	full = false,
}: {
	id: string
	name: string
	value: number
	onChange: (value: number) => void
	/** the type in lower case, e.g. "ordinær" */
	noun: string
	max?: number
	/** no more can be added (+ off) */
	full?: boolean
}) {
	return (
		<div className="tp-stepper">
			<button
				type="button"
				className="tp-step"
				onClick={() => onChange(value - 1)}
				disabled={value === 0}
				aria-label={`Færre ${noun}billettar`}
			>
				−
			</button>
			<input
				id={id}
				type="number"
				inputMode="numeric"
				name={name}
				min={0}
				max={max}
				value={value || ''}
				placeholder="0"
				onChange={(e) => onChange(Number.parseInt(e.target.value, 10) || 0)}
				className="tp-qty"
				aria-label={`Tal på ${noun}billettar`}
			/>
			<button
				type="button"
				className="tp-step"
				onClick={() => onChange(value + 1)}
				disabled={full}
				aria-label={`Fleire ${noun}billettar`}
			>
				+
			</button>
		</div>
	)
}
